<template>
  <div class="rate-select" @mouseleave="rate = 0">
    <div
      class="star"
      :class="{ bright: rate ? index < rate : index < value }"
      v-for="(item, index) in grades"
      :key="index"
      @click="handleClick(index, $event)"
      @mouseenter="rate = index + 1"
    >{{ item }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      grades: ['非常不满意', '不满意', '一般', '满意', '非常满意'],
      rate: 0,
    }
  },
  methods: {
    handleClick(index, e) {
      this.$emit('input', index + 1);
      const el = e.target;
      el.classList.add('bounce');
      setTimeout(() => {
        el.classList.remove('bounce');
      }, 300);
    }
  }
};
</script>

<style lang="less" scoped>
.rate-select {
  display: flex;
  font-size: 12px;
  color: #666;
  .star {
    width: 70px;
    height: 60px;
    background-image: url('@/assets/img/layout/FloatWindow/icon_star.png');
    background-position: center 4px;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    cursor: pointer;
    user-select: none;
    &.bright {
      background-image: url('@/assets/img/layout/FloatWindow/icon_star_bright.png');
      color: @primary-color;
    }
    &.bounce {
      animation: bounce 0.3s;
      animation-timing-function: ease;
      animation-fill-mode: forwards;
      @keyframes bounce {
        0% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-8px);
        }
        100% {
          transform: translateY(0);
        }
      }
    }
  }
}
</style>
